<mat-dialog-content style="height:900px; max-height: 900px;">
    <mat-horizontal-stepper  *ngIf="!loadingmodal" #stepper [linear]="paymentdata?.paymentType === 'PO'">
      

        <mat-step [completed]="step1Completed()" >
            <ng-template matStepLabel>Select Payment Type</ng-template>
            <div class="step1-form">
           
              <mat-form-field   class="full-width">
                <mat-label>Select Payment Type</mat-label>
                <mat-select
                  [(ngModel)]="paymentdata.paymentType"
                  name="paymentType"
                  (selectionChange)="onSelectPaymentType(paymentdata.paymentType)">
                  <mat-option *ngFor="let opt of poOptions" [value]="opt.value">
                    {{ opt.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          
              <mat-form-field   class="full-width" *ngIf="paymentdata.paymentType">
                <mat-label>Select Company</mat-label>
                <mat-select
                  [(ngModel)]="selectedCompany"
                  name="company"
                  (selectionChange)="onSelectCompany(selectedCompany)">
                  <mat-option *ngFor="let co of companyOptions" [value]="co.value">
                    {{ co.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
          
              
              <div *ngIf="paymentdata.paymentType === 'CONSIGNMENT' && selectedCompany; else poTable">

                <div style="display: flex">
                    <div class="input-date-header">
                      <mat-date-range-input
                        [rangePicker]="picker"
                        style="background-color: #f7f7f7"
                      >
                        <input
                        name="sinceDate"
                        [(ngModel)]="sinceDate"
                        [ngModelOptions]="{ standalone: true }"
                          matStartDate
                          placeholder="Start date"
                          style="background-color: #f7f7f7"
                        />
                        <input
                        name="toDate"
                        [(ngModel)]="toDate"
                        [ngModelOptions]="{ standalone: true }"
                          matEndDate
                          placeholder="End date"
                          style="background-color: #f7f7f7"
                        />
                      </mat-date-range-input>
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-date-range-picker #picker></mat-date-range-picker>
                    </div>
                
                  </div>
              </div>
          
            
              <ng-template #poTable>
                <div *ngIf="selectedCompany" style="margin: 1rem 0;">
                  <h4>PO for {{ selectedCompany }}</h4>
                  <ngx-skeleton-loader *ngIf="loading" count="5" appearance="line" animation="pulse"></ngx-skeleton-loader>
                  <dinamic-table
                    *ngIf="!loading"
                    [id]="'popaymentTableEdit'"
                    [dbname]="'popaymentTableEdit'"
                    [frontpaginate]="false"
                    [data]="podata"
                    [config]="options"
                    [perPage]="itemsPorPagina"
                    [page]="paginaActual"
                    [total_items_count]="totalItems"
                    [total_pages]="totalPaginas"
                    (newConfig)="updateConfig($event)"
                    [columnfilters]="filtros"
                    (buscar)="getlistpo($event)"
                    (rightClickAction)="handleRightClick($event)"
                    (bulkListChange)="onBulkChange($event)"
                    [bulk]="bulk"
                  ></dinamic-table>
                </div>
              </ng-template>
            </div>
            <div class="firstubtton" style="text-align:right; margin-top: 1rem;">
              <button
              class="gts-btn-primary-outline"
              matRipple
                style="font-size:smaller;"
                matStepperNext
                [disabled]="
                  (paymentdata.paymentType === 'PO' && bulk.length <= 0) ||
                  (paymentdata.paymentType === 'CONSIGNMENT' && (
                    !paymentdata.CosigmentDetail?.datefrom ||
                    !paymentdata.CosigmentDetail?.dateto
                  ))
                ">
              <span class="gts-btn-text"> Next </span>
              <span class="gts-btn-icon-right">arrow_forward</span>
              </button>
            </div>
          </mat-step>
          
            
        <mat-step>
            <ng-template matStepLabel>
            {{ paymentdata.paymentType === 'PO' ? 'Equipment Receipt Verification' : 'Recoverered Revenue Report' }}
            </ng-template>
            
           
            <div *ngIf="paymentdata.paymentType === 'PO'; else consignmentStep2">
                <h2 class="po-header">PO# {{ poNumbers.join(', ') }}</h2>
                <p>Has the equipment been received?</p>
                <div class="yes-no">
                  <button
                  [ngClass]="{
                    'gts-btn-primary-outline': step2Control.get('received').value !== 'yes',
                    'gts-btn-primary': step2Control.get('received').value === 'yes'
                  }"
                    type="button"
                    [class.selected]="step2Control.get('received').value === 'yes'"
                    (click)="step2Control.get('received').setValue('yes')">
                    YES
                  </button>
                  <button
                  [ngClass]="{
                    'gts-btn-primary-outline': step2Control.get('received').value !== 'no',
                    'gts-btn-primary': step2Control.get('received').value === 'no'
                  }"
                    type="button"
                    [class.selected]="step2Control.get('received').value === 'no'"
                    (click)="step2Control.get('received').setValue('no')">
                    NO
                  </button>
                </div>
                <div *ngIf="step2Control.get('received').value === 'no'">
                  <mat-form-field class="full-width">
                    <mat-label>Justification for upfront payment</mat-label>
                    <textarea matInput  [(ngModel)]="equipmentReceivedComment" rows="2"></textarea>
                    <mat-hint *ngIf="loadingComment">Loading comment...</mat-hint>
                  </mat-form-field>
                </div>
            </div>
        
           
            <ng-template #consignmentStep2>
            
            <app-multi-files
                [idfather]="data.id"
                [type]="'PAYMENT'"
                (total)="onFilesTotalChanged($event)"
                (allUploaded)="onFilesUploaded($event)">
            </app-multi-files>
            </ng-template>
        
            <div class="firstubtton" style="text-align:right; margin-top: 1rem;">
            <button
                class="gts-btn-primary-outline"
                matRipple
                style="font-size:smaller;"
                matStepperNext
               
            >
                <span class="gts-btn-text"> Next </span>
                <span class="gts-btn-icon-right">arrow_forward</span>
            </button>
            </div>
        </mat-step>



        <mat-step *ngIf="paymentdata.paymentType === 'PO'">
            <ng-template matStepLabel>
              {{ paymentdata.paymentType === 'PO' ? 'Equipment Testing and QTY Confirmation' : 'Consignment Details' }}
            </ng-template>
          
            <div *ngIf="paymentdata.paymentType === 'PO'; else consignmentStep3">
              <h2 class="po-header">PO# {{ poNumbers.join(', ') }}</h2>
              <p>Has the equipment been tested and quantities confirmed?</p>
              <div class="yes-no">
                <button
                [ngClass]="{
                  'gts-btn-primary-outline': step3Control.get('tested').value !== 'yes',
                  'gts-btn-primary': step3Control.get('tested').value === 'yes'
                }"
                  type="button"
                  [class.selected]="step3Control.get('tested').value === 'yes'"
                  (click)="step3Control.get('tested').setValue('yes')">
                  YES
                </button>
                <button
                [ngClass]="{
                  'gts-btn-primary-outline': step3Control.get('tested').value !== 'no',
                  'gts-btn-primary': step3Control.get('tested').value === 'no'
                }"
                  type="button"
                  [class.selected]="step3Control.get('tested').value === 'no'"
                  (click)="step3Control.get('tested').setValue('no')">
                  NO
                </button>
              </div>
              <div *ngIf="step3Control.get('tested').value === 'no'">
                <mat-form-field class="full-width">
                  <mat-label> Please provide justification for upfront payment</mat-label>
                  <textarea matInput  [(ngModel)]="testedComment" rows="2"></textarea>
                </mat-form-field>
              </div>

              
            </div>
          
            <ng-template #consignmentStep3>
              <!-- Si hay lógica especial para Consignment, ponla aquí -->
            </ng-template>
          
            <div class="firstubtton" style="text-align:right; margin-top: 1rem;">
              <button
                class="gts-btn-primary-outline"
                matRipple
                style="font-size:smaller;"
                matStepperNext
              >
                <span class="gts-btn-text"> Next </span>
                <span class="gts-btn-icon-right">arrow_forward</span>
              </button>
            </div>
          </mat-step>
          
          <mat-step [completed]="step4Completed()">
            <ng-template matStepLabel>Payment Processing</ng-template>
          
            <ng-container *ngIf="paymentdata.paymentType === 'PO'; else consignmentPP">
            <h2 class="po-header">PO# {{ poNumbersText }}</h2>
            <div class="po-cards-container">
              <div *ngFor="let item of bulkDetails; trackBy: trackById" class="po-card">
                <span class="po-card-title">PO# {{ item.po }}</span>
                <span class="po-card-amount">
                  {{ item.amount | currency:'USD':'symbol':'1.2-2' }}
                </span>
              </div>
              <div class="po-card total-card">
                <span class="po-card-title">Total</span>
                <span class="po-card-amount">{{ bulkTotal }}</span>
              </div>
            </div>
          
           
            <div class="payment-inputs">
              <div class="amount-box">
                <mat-form-field>
                  <mat-label>$ Enter the amount</mat-label>
                  <input
                    matInput
                    type="number"
                    [(ngModel)]="paymentdata.requestedAmount"
                    name="requestedAmount"
                    min="0"
                  >
                  <div matSuffix class="percent-buttons">
                    <button type="button" mat-button (click)="setPercentEdit(1)">100%</button>
                    <button type="button" mat-button (click)="setPercentEdit(0.75)">75%</button>
                    <button type="button" mat-button (click)="setPercentEdit(0.5)">50%</button>
                    <button type="button" mat-button (click)="setPercentEdit(0.25)">25%</button>
                  </div>
                </mat-form-field>
              </div>
          
              <div class="urgency-box">
                <mat-form-field>
                  <mat-label>Payment Urgency</mat-label>
                  <mat-select [(ngModel)]="paymentdata.paymentDueType" name="paymentDueType">
                    <mat-option value="ASAP">ASAP</mat-option>
                    <mat-option value="Next Payment Run">Next payment run</mat-option>
                    <mat-option value="SpecificDate">Specific date</mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="paymentdata.paymentDueType === 'SpecificDate'" class="specific-date-box">
                  <mat-form-field class="full-width">
                    <mat-label>Payment Date</mat-label>
                    <input
                      matInput
                      [matDatepicker]="specPicker"
                      [(ngModel)]="paymentdata.paymentDueDate"
                      name="paymentDueDate">
                    <mat-datepicker-toggle matSuffix [for]="specPicker"></mat-datepicker-toggle>
                    <mat-datepicker #specPicker></mat-datepicker>
                    <mat-error *ngIf="!paymentdata.paymentDueDate">
                      Date is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
        </ng-container>
        <ng-template #consignmentPP>
            <div class="consignment-header">
              <h2 class="po-header">Consignment</h2>
              <p class="date-range">
                {{ sinceDate | date:'MM/dd/yyyy' }} – {{ toDate | date:'MM/dd/yyyy' }}
              </p>
            </div>
            <div class="po-cards-container">
              <div class="po-card total-card">
                <span class="po-card-title">Total</span>
                <span class="po-card-amount">
                  {{ consignmentTotal }}
                </span>
              </div>
            </div>
            <div class="payment-inputs">
              <div class="amount-box">
                <mat-form-field>
                  <mat-label>$ Enter the amount</mat-label>
                  <input
                    matInput
                    required 
                    type="number"
                    [(ngModel)]="paymentdata.requestedAmount"
                    name="requestedAmount"
                    min="0"
                  >
                </mat-form-field>
              </div>
              <div class="urgency-box">
                <mat-form-field>
                  <mat-label>Payment Urgency</mat-label>
                  <mat-select [(ngModel)]="paymentdata.paymentDueType" name="paymentDueType">
                    <mat-option value="ASAP">ASAP</mat-option>
                    <mat-option value="Next Payment Run">Next payment run</mat-option>
                    <mat-option value="SpecificDate">Specific date</mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="paymentdata.paymentDueType === 'SpecificDate'" class="specific-date-box">
                  <mat-form-field class="full-width">
                    <mat-label>Payment Date</mat-label>
                    <input
                      matInput
                      required 
                      [matDatepicker]="specPicker"
                      [(ngModel)]="paymentdata.paymentDueDate"
                      name="paymentDueDate">
                    <mat-datepicker-toggle matSuffix [for]="specPicker"></mat-datepicker-toggle>
                    <mat-datepicker #specPicker></mat-datepicker>
                    <mat-error *ngIf="!paymentdata.paymentDueDate">
                      Date is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </ng-template>
       
          <div *ngIf="!loadingmodal && selectedPaymentMethod" style="margin-top:32px">
            <span style="font-size:18px; color:#836979;">Select Payment Method :</span>
            <mat-tab-group *ngIf="paymentdata.methodDetail"
              class="payment-method-tabs"
              animationDuration="0ms"
              [selectedIndex]="getSelectedMethodTabIndex()"
              (selectedIndexChange)="onMethodTabChange($event)">
            >
              
              <mat-tab label="Check – Pick-up">
                <div style="padding:16px;">
                  <mat-form-field class="full-width">
                    <mat-label>Invoice Number</mat-label>
                    <input required  matInput [(ngModel)]="paymentdata.methodDetail.invoiceNumber" name="invoiceNumber" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Pickup Date</mat-label>
                    <input required matInput [matDatepicker]="pickupDatePicker" [(ngModel)]="paymentdata.methodDetail.pickupDatetime" name="pickupDatetime">
                    <mat-datepicker-toggle matSuffix [for]="pickupDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #pickupDatePicker></mat-datepicker>
                  </mat-form-field>
                  <div style="margin-bottom:12px;">
                    <span>Number of Checks: </span>
                    <button mat-icon-button (click)="decrementChecksEdit()" [disabled]="paymentdata.methodDetail.numberOfChecks <= 1"><mat-icon>remove</mat-icon></button>
                    <span>{{ paymentdata.methodDetail.numberOfChecks || 1 }}</span>
                    <button mat-icon-button (click)="incrementChecksEdit()" [disabled]="paymentdata.methodDetail.numberOfChecks >= 5"><mat-icon>add</mat-icon></button>
                  </div>
                  <div *ngFor="let check of checksArray">
                    <div style="display:flex; gap:12px; margin-bottom:8px;">
                      <mat-form-field style="flex:2;">
                        <mat-label>Check Payable To #{{ check.idx }}</mat-label>
                        <input required matInput [(ngModel)]="paymentdata.methodDetail['checkPayableTo' + check.idx]" name="checkPayableTo{{check.idx}}" />
                      </mat-form-field>
                      <mat-form-field style="flex:1;">
                        <mat-label>Check Amount #{{ check.idx }}</mat-label>
                        <input required matInput type="number" [(ngModel)]="paymentdata.methodDetail['checkAmount' + check.idx]" name="checkAmount{{check.idx}}" min="0" />
                      </mat-form-field>
                    
                    </div>
                    <hr>
                  </div>
                </div>
              </mat-tab>
          
      
              <mat-tab label="Check – Mailed">
                <div style="padding:16px;">
                  <mat-form-field class="full-width">
                    <mat-label>Invoice number (if available)</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.invoiceNumber" name="invoiceNumber" />
                  </mat-form-field>
                  <div style="margin-bottom:12px;">
                    <span>Number of Checks: </span>
                    <button mat-icon-button (click)="decrementChecksEdit()" [disabled]="paymentdata.methodDetail.numberOfChecks <= 1"><mat-icon>remove</mat-icon></button>
                    <span>{{ paymentdata.methodDetail.numberOfChecks || 1 }}</span>
                    <button mat-icon-button (click)="incrementChecksEdit()" [disabled]="paymentdata.methodDetail.numberOfChecks >= 5"><mat-icon>add</mat-icon></button>
                  </div>
                  <div *ngFor="let check of checksArray">
                    <mat-form-field class="full-width">
                      <mat-label>Check payable to</mat-label>
                      <input required matInput [(ngModel)]="paymentdata.methodDetail['checkPayableTo' + check.idx]" name="checkPayableTo{{check.idx}}" />
                    </mat-form-field>
                    <mat-form-field class="full-width">
                      <mat-label>Check amount</mat-label>
                      <input required matInput type="number" [(ngModel)]="paymentdata.methodDetail['checkAmount' + check.idx]" name="checkAmount{{check.idx}}" min="0" />
                    </mat-form-field>
                  </div>
                  <mat-form-field class="full-width">
                    <mat-label>Shipping address</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.shippingAddress" name="shippingAddress" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Select Shipping Method</mat-label>
                    <mat-select [(ngModel)]="paymentdata.methodDetail.shippingMethod" name="shippingMethod" required>
                      <mat-option *ngFor="let method of shippingMethods" [value]="method">{{ method }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </mat-tab>
              <mat-tab label="ACH-Domestic">
                <div style="padding:16px;">
                  <mat-form-field class="full-width">
                    <mat-label>Invoice number (if available)</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.invoiceNumber" name="invoiceNumberACH" />
                  </mat-form-field>
                  <div class="method-toggle">
                    <mat-slide-toggle
                      [checked]="ACHDOME === 'manual'"
                      (change)="setACHDOME('manual')"
                    >
                      Add Info Manually
                    </mat-slide-toggle>
                  
                    <mat-slide-toggle
                      [checked]="ACHDOME === 'file'"
                      (change)="setACHDOME('file')"
                    >
                      Add a File
                    </mat-slide-toggle>
                  </div>
                  <ng-container *ngIf="ACHDOME === 'manual'"> 
                  <mat-form-field class="full-width">
                    <mat-label>Beneficiary name</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.achBeneficiaryName" name="achBeneficiaryName" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Routing Number</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.achRoutingNumber" name="achRoutingNumber" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Account Number</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.achAccountNumber" name="achAccountNumber" />
                  </mat-form-field>
                </ng-container>
                <ng-container *ngIf="ACHDOME === 'file'">
                  <app-multi-files
                    [idfather]="paymentID"
                    [type]="notesType"
                    (total)="onFilesTotalChanged($event)"
                    (allUploaded)="onFilesUploaded($event)">
                  </app-multi-files>
                </ng-container>
                </div>
              </mat-tab>
              <mat-tab label="WT - International">
                <div style="padding:16px;">
                  <mat-form-field class="full-width">
                    <mat-label>Invoice number (if available)</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.invoiceNumber" name="invoiceNumberWTInt" />
                  </mat-form-field>
                  <div class="method-toggle">
                    <mat-slide-toggle
                      [checked]="WTINT === 'manual'"
                      (change)="setWTINT('manual')"
                    >
                      Add Info Manually
                    </mat-slide-toggle>
                  
                    <mat-slide-toggle
                      [checked]="WTINT === 'file'"
                      (change)="setWTINT('file')"
                    >
                      Add a File
                    </mat-slide-toggle>
                  </div>
                  <ng-container *ngIf="WTINT === 'manual'">  
                  <mat-form-field class="full-width">
                    <mat-label>Beneficiary name</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.wtBeneficiaryName" name="wtBeneficiaryName" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Beneficiary address</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.wtBeneficiaryAddress" name="wtBeneficiaryAddress" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>CLABE (Account Number)</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.wtClabe" name="wtClabe" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>SWIFT (Bank Code)</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.wtSwiftCode" name="wtSwiftCode" />
                  </mat-form-field>
                </ng-container>

                <ng-container *ngIf="WTINT === 'file'">
                  <app-multi-files
                    [idfather]="paymentID"
                    [type]="notesType"
                    (total)="onFilesTotalChanged($event)"
                    (allUploaded)="onFilesUploaded($event)">
                  </app-multi-files>
                </ng-container>
                </div>
              </mat-tab>
              <mat-tab label="WT - Domestic">
                <div style="padding:16px;">
                  <mat-form-field class="full-width">
                    <mat-label>Invoice number (if available)</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.invoiceNumber" name="invoiceNumberWTDomestic" />
                  </mat-form-field>
                  <div class="method-toggle">
                    <mat-slide-toggle
                      [checked]="WTDOME === 'manual'"
                      (change)="setWTDOME('manual')"
                    >
                      Add Info Manually
                    </mat-slide-toggle>
                  
                    <mat-slide-toggle
                      [checked]="WTDOME === 'file'"
                      (change)="setWTDOME('file')"
                    >
                      Add a File
                    </mat-slide-toggle>
                  </div>
                  <ng-container *ngIf="WTDOME === 'manual'">
                  <mat-form-field class="full-width">
                    <mat-label>Beneficiary name</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.wtBeneficiaryName" name="wtBeneficiaryName" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Beneficiary address</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.wtDomesticBeneficiaryAddress" name="wtDomesticBeneficiaryAddress" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Account Number</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.wtDomesticAccountNumber" name="wtDomesticAccountNumber" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Routing Number</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.wtDomesticRoutingNumber" name="wtDomesticRoutingNumber" />
                  </mat-form-field>
                </ng-container>

                <ng-container *ngIf="WTDOME === 'file'">
                  <app-multi-files
                    [idfather]="paymentID"
                    [type]="notesType"
                    (total)="onFilesTotalChanged($event)"
                    (allUploaded)="onFilesUploaded($event)">
                  </app-multi-files>
                </ng-container>
                </div>
              </mat-tab>
              
              <mat-tab label="PayPal">
                <div style="padding:16px;">
                  <mat-form-field class="full-width">
                    <mat-label>Invoice number (if available)</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.invoiceNumber" name="invoiceNumberPaypal" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Customer email</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.paypalEmail" name="paypalEmail" />
                  </mat-form-field>
                </div>
              </mat-tab>
              
              <mat-tab label="Credit Card">
                <div style="padding:16px;">
                  <mat-form-field class="full-width">
                    <mat-label>Invoice number (if available)</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.invoiceNumber" name="invoiceNumberCC" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>AR department contact</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.ccContactName" name="ccContactName" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Phone number</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.ccPhoneNumber" name="ccPhoneNumber" />
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>AR department email</mat-label>
                    <input required matInput [(ngModel)]="paymentdata.methodDetail.ccContactEmail" name="ccContactEmail" />
                  </mat-form-field>
                </div>
              </mat-tab>
                            
       
            </mat-tab-group>
          </div>
          <div class="actions">
             
          
            <button
            class="gts-btn-primary-outline"
            style="font-size:smaller;"
            matRipple
            matStepperPrevious
                  >
       
                  <span class="gts-btn-icon-left">  arrow_back</span>
          <span class="gts-btn-text"> Previous </span>
          </button>

            <button
            class="gts-btn-primary-outline"
            style="font-size:smaller;"
            matRipple
            matStepperNext
      
                  >
       
          <span class="gts-btn-text"> Next </span>
          <span class="gts-btn-icon-right"  *ngIf="!saving">arrow_forward</span>
          
          </button>
      
        </div>
          </mat-step>
          
  
        <mat-step>
          <ng-template matStepLabel>Additional Notes(Optional)</ng-template>
          <h2  *ngIf="paymentdata.paymentType === 'PO'" class="po-header">
              PO# {{ poNumbers.join(', ') }}
            </h2>
            <form class="step5-form">
            <mat-form-field  >
              <mat-label>Additional Notes(Optional)</mat-label>
              <textarea  matInput   [(ngModel)]="notecomment" rows="2"> </textarea>
            </mat-form-field>
          </form>
            <div class="actions">
              <!-- <button mat-button  >
                  Save
                </button> -->
                <button
                class="gts-btn-primary-outline"
                style="font-size:smaller;"
                matRipple
                matStepperPrevious
                      >
           
                      <span class="gts-btn-icon-left">  arrow_back</span>
              <span class="gts-btn-text"> Previous </span>
              </button>
              <button   class="gts-btn-primary-outline"matRipple (click)="submitEdit()"  style="font-size:smaller;" [disabled]="submitting">
                <span class="gts-btn-text" *ngIf="!submitting">Submit</span>
 
                <i
                  class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"
                  *ngIf="submitting"
                ></i>
              </button>
            </div>
        </mat-step>
    </mat-horizontal-stepper>

    <ngx-skeleton-loader
    *ngIf="loadingmodal"
    count="10"
    appearance="line"
    animation="pulse">
  </ngx-skeleton-loader>
  </mat-dialog-content>
  